import {
  IconButton,
  Dialog,
  DialogTitle,
  AppBar,
  Toolbar,
  Typography,
  Box,
  CircularProgress,
  DialogContent,
  DialogActions,
  Tooltip,
  Button,
  TextField,
  Autocomplete,
  ListItem,
  ListItemAvatar,
  Checkbox,
  ListItemText,
  FormControlLabel,
} from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { currencyFormat } from "../../common/components/Utils";

import {
  saveTrainer,
  saveCohortVenueTrainees,
} from "../../../../store/cpd/actions";
import { getDistricts, getSectors } from "../../../../store/posts/actions";

import { isEmpty } from "lodash";
import axios from "axios";
import { CSVLink } from "react-csv";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import moment from "moment";
// import { showError } from "../../toastify";
import defaultPofile from "../../../assets/default-profile.jpg";
import { idNumberPattern } from "../../common/components/Utils";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import MaskedInput from "react-text-mask";
import joi from "joi";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import ReactPaginate from "react-paginate";
import SearchBox from "../../common/components/SearchBox";
import { showError } from "../../../toastify";

const TraineesFormDialog = (props) => {
  const {
    user,
    loading,
    showDialog,
    setShowDialog,
    training,
    cohortVenue,
    saveTrainer,
    saveCohortVenueTrainees,
    getTrainingCohorts,
    currentTrainees,
  } = props;

  const [trainees, setTrainees] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [selectedTrainees, setSelectedTrainees] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredItems, setFilteredItems] = useState([...trainees]);

  // PAGINATION (must be defined before derived page selections)
  const [paginatedItems, setPaginatedItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);

  const [itemOffset, setItemOffset] = useState(0);

  const itemsPerPage = 10;

  const paginate = (items) => {
    const endOffset = itemOffset + itemsPerPage;
    setPaginatedItems(items.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(items.length / itemsPerPage));
  };

  const currentTraineeIds = Array.isArray(currentTrainees)
    ? currentTrainees
    : [];
  const venueCapacity = +cohortVenue?.numOfTrainees || 0;
  const totalSelected =
    (currentTraineeIds.length || 0) + selectedTrainees.length;
  const remainingCapacity = Math.max(0, venueCapacity - totalSelected);
  const hasMetRequired =
    venueCapacity > 0 ? totalSelected >= venueCapacity : false;

  const pageSelectableIds = (
    Array.isArray(paginatedItems) ? paginatedItems : []
  )
    .map((t) => t?.id)
    .filter((id) => id != null && !currentTraineeIds.includes(id));

  const pageSelectedIds = new Set(selectedTrainees);
  const isAllSelectableOnPageSelected =
    pageSelectableIds.length > 0 &&
    pageSelectableIds.every((id) => pageSelectedIds.has(id));

  const isSomeSelectableOnPageSelected =
    pageSelectableIds.some((id) => pageSelectedIds.has(id)) &&
    !isAllSelectableOnPageSelected;

  useEffect(() => {
    const filtered = [...trainees].filter(
      ({
        id,
        employeeId,
        lastName,
        firstName,
        nidNumber,
        phoneNumber,
        email,
        positionName,
        role,
      }) =>
        (
          (id || "") +
          (employeeId || "") +
          (lastName || "") +
          (firstName || "") +
          (nidNumber || "") +
          (phoneNumber || "") +
          (email || "") +
          (positionName || "") +
          (role || "")
        )
          .replace(/\s/g, "")
          .toLowerCase()
          .includes(searchTerm.toLowerCase().replace(/\s/g, "")),
    );
    setFilteredItems(filtered);

    paginate(filtered);
  }, [searchTerm, trainees]);

  const onClose = () => {
    setShowDialog(false);
  };

  useEffect(() => {
    if (!showDialog) return;
    if (!cohortVenue?.id) return;
    searchTrainees(cohortVenue.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showDialog, cohortVenue?.id, user?.id]);

  const searchTrainees = async (trainingCohortVenueId) => {
    try {
      setIsLoading(true);

      setTrainees([]);

      const { data } = await axios.get(
        `/api/cpd/search-trainees/${trainingCohortVenueId}`,
      );

      const list = Array.isArray(data) ? data : [];
      const myUserId =
        user?.id != null ? String(user.id).trim() : "";
      setTrainees(
        myUserId
          ? list.filter(
              (t) => String(t?.id ?? "").trim() !== myUserId,
            )
          : list,
      );

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    paginate(filteredItems);
  }, [itemOffset, itemsPerPage, filteredItems]);

  const handlePageClick = (event) => {
    const newOffset =
      (event.selected * itemsPerPage) % filteredItems.length || 0;

    setItemOffset(newOffset);
  };

  const getNo = (data, key, idToSearch) =>
    data.findIndex((item) => item[key] === idToSearch);

  const onSave = () => {
    if (!cohortVenue?.id) return showError("Venue is missing.");
    if (venueCapacity > 0 && totalSelected > venueCapacity)
      return showError(
        "The number of trainees cannot exceed the venue capacity.",
      );
    saveCohortVenueTrainees(
      {
        trainingCohortVenueId: cohortVenue.id,
        trainees: selectedTrainees,
      },
      () => {
        getTrainingCohorts(training.id);
        onClose();
      },
    );
  };

  const onSearch = (term) => {
    setSearchTerm(term);
  };

  const toggleSelectPage = (checked) => {
    const selectableIds = pageSelectableIds;
    const tmp = new Set(selectedTrainees);

    if (!checked) {
      selectableIds.forEach((id) => tmp.delete(id));
      setSelectedTrainees([...tmp]);
      return;
    }

    const idsToAdd = selectableIds.filter((id) => !tmp.has(id));
    if (idsToAdd.length === 0) {
      // Already selected on this page; nothing to do.
      return;
    }

    if (remainingCapacity <= 0) {
      showError("The number of trainees cannot exceed the venue capacity.");
      return;
    }

    let added = 0;
    for (const id of idsToAdd) {
      if (added >= remainingCapacity) break;
      tmp.add(id);
      added++;
    }

    if (added === 0) {
      showError("The number of trainees cannot exceed the venue capacity.");
      return;
    }

    if (added < idsToAdd.length) {
      showError("Only some teachers were selected (venue capacity reached).");
    }

    setSelectedTrainees([...tmp]);
  };

  return (
    <>
      <Dialog onClose={onClose} open={showDialog} fullWidth maxWidth="lg">
        <DialogTitle className="text-primary pb-0 mb-0 text-uppercase border">
          <span className="d-flex align-items-center mb-2">
            <Typography className="d-flex align-items-center text-primary">
              <span className="text-dark mr-1">Add trainees</span>
            </Typography>
          </span>

          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <div
            style={{
              minHeight: "35vh",
              // padding: "10px",
            }}
          >
            <Box sx={{ display: { xs: "flex", md: "flex" } }} className="py-1">
              <SearchBox onSearch={onSearch} placeholder="Search…" />
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                mb: 1,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      indeterminate={isSomeSelectableOnPageSelected}
                      checked={!!isAllSelectableOnPageSelected}
                      onChange={(e) => toggleSelectPage(e.target.checked)}
                      disabled={
                        !pageSelectableIds.length || remainingCapacity <= 0
                      }
                    />
                  }
                  label="Select page"
                />
                <Typography
                  variant="body2"
                  sx={{
                    color: hasMetRequired ? "success.main" : "text.secondary",
                  }}
                >
                  Selected: <strong>{totalSelected}</strong> /{" "}
                  {venueCapacity || 0}
                </Typography>
              </Box>

              {!hasMetRequired && venueCapacity > 0 && (
                <Typography variant="body2" sx={{ color: "warning.main" }}>
                  Remaining:{" "}
                  <strong>{Math.max(0, venueCapacity - totalSelected)}</strong>
                </Typography>
              )}
              {hasMetRequired && venueCapacity > 0 && (
                <Typography variant="body2" sx={{ color: "success.main" }}>
                  Required trainees met
                </Typography>
              )}
            </Box>

            {isLoading && (
              <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
                <CircularProgress size={28} />
              </Box>
            )}

            {!!paginatedItems?.length && (
              <table className="table table-striped table-sm">
                <thead>
                  <tr style={{ backgroundColor: "#f0f2f5" }}>
                    <th scope="col">#</th>
                    <th scope="col">EmployeeId</th>
                    <th scope="col">Names</th>
                    <th scope="col">NID Number</th>
                    <th scope="col">Position</th>
                    <th scope="col">Role</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {paginatedItems?.map((item, trainerIndex) => (
                    <tr key={item.id}>
                      <td className="text-left">{trainerIndex + 1}</td>
                      <td className="text-left">
                        <strong>{item.employeeId}</strong>
                      </td>
                      <td className="text-left">
                        {item.lastName} {item.firstName}
                      </td>
                      <td className="text-left">{item.nidNumber}</td>
                      <td className="text-left">{item.positionName}</td>
                      <td className="text-left">{item.role}</td>
                      <td className="text-left">
                        <Checkbox
                          disabled={currentTraineeIds.includes(item.id)}
                          checked={[
                            ...currentTraineeIds,
                            ...selectedTrainees,
                          ].includes(item.id)}
                          size="small"
                          onClick={(e) => {
                            const tmpTrainees = new Set(selectedTrainees);

                            if (e.target.checked) {
                              if (
                                (currentTraineeIds.length || 0) +
                                  selectedTrainees.length >=
                                venueCapacity
                              )
                                return showError(
                                  "The number of trainees cannot exceed the venue capacity.",
                                );
                              tmpTrainees.add(item.id);
                            } else tmpTrainees.delete(item.id);

                            setSelectedTrainees([...tmpTrainees]);
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            {!isLoading && !trainees?.length && (
              <div className="container text-center jumbotron py-3">
                <p className="lead">No teachers found</p>
              </div>
            )}

            {trainees.length > itemsPerPage && (
              <ReactPaginate
                breakLabel="..."
                nextLabel={
                  <>
                    <i className="fas fa-angle-double-right"></i>
                  </>
                }
                previousLabel={
                  <>
                    <i className="fas fa-angle-double-left"></i>
                  </>
                }
                pageRangeDisplayed={2}
                marginPagesDisplayed={1}
                onPageChange={handlePageClick}
                pageCount={pageCount}
                renderOnZeroPageCount={null}
                containerClassName="pagination"
                pageLinkClassName="btn btn-outline-dark btn-sm mr-1 ml-1"
                previousLinkClassName="btn btn-outline-dark btn-sm mr-1 ml-1"
                nextLinkClassName="btn btn-outline-dark btn-sm ml-1"
                activeLinkClassName="active"
              />
            )}
          </div>
        </DialogContent>
        <DialogActions className=" d-flex justify-content-center pb-3">
          <Button
            disabled={loading}
            color="primary"
            variant="contained"
            disableElevation
            size="sm"
            className="px-5"
            onClick={onSave}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const mapStateToProps = ({
  user,
  loading,
  onWait,
  placementReportDetails,
  changeList,
  prevPlacementReport,
  signatories,
  roles,
  districts,
  sectors,
  trainerCategories,
  trainingProviders,
}) => {
  return {
    user,
    loading,
    onWait,
    placementReportDetails,
    changeList,
    prevPlacementReport,
    signatories,
    roles,
    districts,
    sectors,
    trainerCategories,
    trainingProviders,
  };
};
export default connect(mapStateToProps, {
  saveTrainer,
  getSectors,
  getDistricts,
  saveCohortVenueTrainees,
})(TraineesFormDialog);
